module.exports = __webpack_public_path__ + "img/collect_icon_03.61af459d.png";